import {
  createContext, useContext, useEffect, useRef,
} from 'react';

const TableScrollContext = createContext(null);

export const useTableScrollDismiss = (dismiss) => {
  const context = useContext(TableScrollContext);
  const dismissRef = useRef(dismiss);

  useEffect(() => {
    dismissRef.current = dismiss;
  });

  useEffect(() => {
    if (!context || typeof context.subscribe !== 'function') return undefined;
    return context.subscribe(() => dismissRef.current());
  }, [context]);
};

export default TableScrollContext;
